var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialOutlineX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.765 7.75l.205.106 3.946 5.621 4.966-5.642.187-.085h1.412l.188.415-5.828 6.627 6.364 9.064-.205.394h-4.765l-.205-.106-4.18-5.954-5.25 5.975-.189.085H8l-.188-.415 6.117-6.957-6.134-8.734L8 7.75h4.765zm2.395 8.191l.634.887 4.236 5.932h1.553l-5.001-6.998v-.001l-.632-.886-3.99-5.584h-1.554l4.754 6.65z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeLinejoin: "bevel"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social-outline--X-2d1e647b1d95361d4434ae2902d472c9.svg";
export { SvgIconSocialOutlineX as Component };